import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {HttpErrorService} from '../../../core/services/http-error.service';
import {CustomInputComponent} from '../../../components/custom-input/custom-input.component';
import {ButtonComponent} from '../../../components/button/button.component';
import {QRCodeComponent} from 'angularx-qrcode';
import {confirmSignIn} from 'aws-amplify/auth';
import {updateMFAPreference} from 'aws-amplify/auth';
import {
  HTTP_ERROR_CONSTANT, LABEL_CONSTANT,
  MFA_SETUP_CONSTANT,
  PLACEHOLDER_CONSTANT,
  VALIDATION_ERROR_CONSTANT
} from '../../../constant/constant';
import {FormControlPipe} from "../../../shared/pipes/formControl.pipe";

@Component({
  selector: 'app-mfa-setup',
  standalone: true,
  imports: [
    CustomInputComponent,
    ReactiveFormsModule,
    ButtonComponent,
    QRCodeComponent,
    FormControlPipe,
  ],
  templateUrl: './mfa-setup.component.html',
  styleUrl: './mfa-setup.component.scss'
})
export class MfaSetupComponent {

  @Input() totpSetupDetails: any | null = null;
  @Input() userName: string = '';
  @Output() setSignInState: EventEmitter<string> = new EventEmitter<string>();
  @Output() routeToApplicationGettingDefaultOrgDetails: EventEmitter<void> = new EventEmitter<void>();
  @Output() setResetFlowUsername: EventEmitter<string> = new EventEmitter<string>();

  MFA_SETUP_CONSTANT = MFA_SETUP_CONSTANT;
  VALIDATION_ERROR_CONSTANT = VALIDATION_ERROR_CONSTANT;
  PLACEHOLDER_CONSTANT = PLACEHOLDER_CONSTANT;
  LABEL_CONSTANT = LABEL_CONSTANT;
  mfaSetupForm: FormGroup;
  qrCodeUrl: URL | null = null;
  isVerifying = false;

  constructor(
    private _formBuilder: FormBuilder,
    private _httpErrorService: HttpErrorService,
  ) {
    this.mfaSetupForm = this._formBuilder.group({
      verificationCode: ['', [
        Validators.required,
        Validators.pattern('^[0-9]{6}$')
      ]]
    });
  }

  async ngOnInit() {
    try {
      this.qrCodeUrl = this.totpSetupDetails?.totpSetupDetails.getSetupUri(
        `CareConnectNX`,
        this.totpSetupDetails?.username
      ) as URL;
    } catch (error) {
      this._httpErrorService.httpError.set(HTTP_ERROR_CONSTANT.MFA_FAILED);
    }
  }

  async onVerify(): Promise<void> {
    if (this.mfaSetupForm.valid && !this.isVerifying) {
      this.isVerifying = true;
      try {
        const code = this.mfaSetupForm.get('verificationCode')?.value;
        const isVerified = await confirmSignIn({challengeResponse: code});
        if (isVerified.nextStep.signInStep === 'DONE') {
          await updateMFAPreference({ totp: 'PREFERRED' });
          this.routeToApplicationGettingDefaultOrgDetails.emit();
          this.setResetFlowUsername.emit(this.userName);
        }
      } catch (error: unknown) {
        if (error instanceof Error) {
          this._httpErrorService.httpError.set(error.message);
        }
      } finally {
        this.isVerifying = false;
      }
    }
  }
}
